// Search-tag helpers split from HapTimelinePanel.tsx so route head() code
// does not pull the full page layout into the shared first-load bundle.


export const STEPS = [
  {
    day: "Day 0",
    title: "Landlord + tenant match",
    body: "Voucher-holder tours the property. Landlord confirms rent, security deposit, and lease term. Landlord submits RTA (Request for Tenancy Approval) packet to the local PHA.",
  },
  {
    day: "Day 5–15",
    title: "PHA rent reasonableness review",
    body: "PHA compares proposed rent to comparable non-voucher units. Rent may be adjusted to align with the local Payment Standard.",
  },
  {
    day: "Day 15–30",
    title: "HQS inspection scheduled",
    body: "HUD Housing Quality Standards inspection covers smoke/CO detectors, GFCI outlets, heat, roof, plumbing, egress, handrails. Failed items must be cured before HAP execution.",
  },
  {
    day: "Day 30–45",
    title: "HAP contract executed",
    body: "PHA signs the HAP contract with the landlord. Contract sets the HAP portion, tenant portion, and effective date.",
  },
  {
    day: "Day 45–60",
    title: "First HAP payment deposited",
    body: "HAP payment lands via ACH on the first business day of the month following contract effective date. Prorated first-month rent is common.",
  },
  {
    day: "Annual",
    title: "Re-inspection + rent adjustment",
    body: "PHA re-inspects annually (or on-demand for complaints) and adjusts Payment Standard, tenant income share, and rent reasonableness each year.",
  },
];

export function hapTimelineHowToJsonLd(url: string) {
  return {
    "@context": "https://schema.org",
    "@type": "HowTo",
    name: "How Section 8 pays landlords — HAP contract timeline",
    description:
      "Housing Assistance Payment (HAP) timeline from voucher-holder match to first ACH deposit under the HUD Housing Choice Voucher program.",
    url: `${url}#hap-timeline`,
    step: STEPS.map((s) => ({
      "@type": "HowToStep",
      name: `${s.day} — ${s.title}`,
      text: s.body,
    })),
  };
}
